module.exports = __webpack_public_path__ + "img/second_image_zhaojiaxiao@2x.ec13677b.png";